import { render, staticRenderFns } from "./SessionLengthSetter.vue?vue&type=template&id=332259c8"
import script from "./SessionLengthSetter.vue?vue&type=script&lang=js"
export * from "./SessionLengthSetter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports